<template>
  <div class="flex flex-wrap flex-auto">
    <div v-for="(item, i) in details" :key="`details-${i}`" :class="[item.class, itemClass]">
      <span class="block font-medium text-text-tertiary">{{ item.label }}</span>

      <component
        :is="item.onClick ? 'button' : 'span'"
        class="flex items-center mt-1 space-x-2"
        :class="[item.detailClass, detailClass]"
        @click="() => item.onClick || {}"
      >
        <slot :name="formatSlotName(item)">
          <FontAwesomeIcon v-if="item.icon" :icon="item.icon" />
          <span :class="item.textClass">{{ item.detail ? item.detail : formatDetail(item.value, item) }}</span>
        </slot>
      </component>
      <span v-if="item.hint" class="text-xs font-medium text-text-tertiary">{{ item.hint }}</span>
    </div>
  </div>
</template>

<script>
import { isArray, isBoolean } from 'lodash'
export default {
  name: 'UtilListingOverviewDetails',
  props: {
    details: { type: Array },
    itemClass: { type: null, default: 'mb-4 mr-4' },
    detailClass: { type: null, default: 'font-medium text-text-secondary' }
  },

  methods: {
    formatSlotName(item) {
      const name = item.key || item.label
      return name
    },

    formatDetail(detail, options = {}) {
      /*
      type
      suffix
      prefix
      transform - function or string (comma join)
      placeholder
      */
      const placeholder = options.placeholder || '-'
      const suffix = options.suffix || ''

      let formattedDetail

      const isFloat = value => {
        return /^-?\d+(\.\d+)?$/.test(value)
      }

      // array
      if (isArray(detail)) {
        formattedDetail = detail.join(', ')
      } else if (isFloat(detail)) {
        // float
        formattedDetail = parseFloat(detail)

        // number
      } else if (isFinite(detail)) {
        formattedDetail = detail ? detail : ''

        // boolean
      } else if (isBoolean(detail)) {
        formattedDetail = detail ? 'Yes' : 'No'

        // string
      } else {
        formattedDetail = detail
      }

      if (!formattedDetail && !isBoolean(formattedDetail)) {
        formattedDetail = placeholder
      } else {
        formattedDetail = `${formattedDetail}${suffix}`
      }

      return formattedDetail
    }
  }
}
</script>

<style lang="scss" scoped></style>
